import {createContext} from 'react';

export const EditEntryContext = createContext(null);
